import { useEffect, useState } from "react";
import React from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { createAdminCompany, updateAdminCompany } from "../../slices/admin/thunk";



const AdminCompanyModal = ({ show, onCloseClick, data }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isShowError, setShowError] = useState(false);
    const isNewCompany = data === null;

    const defaultCompanyData = {
        id: '',
        name: '',
        contact: '',
        system_type: 'INTERNAL',
        website_version: '',
        user_manual: '',
        is_enabled: true,
        created_at: Math.floor(Date.now() / 1000),
        updated_at: Math.floor(Date.now() / 1000),
        remark: ''
    };

    const [companyData, setCompanyData] = useState(() => ({
        ...defaultCompanyData,
        ...(data ?? {})
    }));

    useEffect(() => {
        if (show) {
            setCompanyData({
                ...defaultCompanyData,
                ...(data ?? {})
            });
        }
    }, [show, data]);

    const closeModal = () => {
        setShowError(false);
        onCloseClick(companyData);
    }

    // Safe input handler with fallbacks
    const handleChange = (field) => (e) => {
        let value = e.target.value || '';
        if (field === 'is_enabled') {
            value = value === 'true';
        }

        setCompanyData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <Modal isOpen={show} toggle={() => { closeModal(false) }} centered={true} size="lg">
            <div className="modal-header">
                <div className="modal-title">{isNewCompany ? t('PageAdmin.Btn.CreateCompany') : t('PageAdmin.Btn.ModifyCompany')}</div>
                <div className="d-flex flex-row modal-close-btn">
                    <Button type="button" className="btn-close btn-sm btn-light" onClick={() => { closeModal(false); }} ></Button>
                </div>
            </div>
            <ModalBody className="d-flex flex-column">
                <form>
                    {isNewCompany ? null :
                        <div className="row">
                            <div className="col-md-3">
                                <label className="col-form-label" htmlFor="admin-company-id">{t('PageAdmin.CompanyTable.ID')}</label>
                            </div>
                            <div className="col-md-9">
                                <input type="text" className="form-control" id="admin-company-id" value={companyData.id} disabled />
                            </div>
                        </div>}
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-company-name">{t('PageAdmin.CompanyTable.Name')}</label>
                        </div>
                        <div className="col-md-9">
                            <input type="text" maxLength={50} className="form-control" id="admin-company-name" value={companyData.name} onChange={handleChange("name")} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-company-contact">{t('PageAdmin.CompanyTable.Contact')}</label>
                        </div>
                        <div className="col-md-9" >
                            <input type="text" maxLength={200} className="form-control" id="admin-company-contact" value={companyData.contact} onChange={handleChange("contact")} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-company-system-type">{t('PageAdmin.CompanyTable.SystemType')}</label>
                        </div>
                        <div className="col-md-9">
                            <select
                                className="form-control"
                                id="admin-company-system-type"
                                value={companyData.system_type}
                                onChange={handleChange("system_type")}
                            >
                                <option value="INTERNAL">INTERNAL</option>
                                <option value="CLOUD">CLOUD</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-company-website-version">{t('PageAdmin.CompanyTable.WebsiteVersion')}</label>
                        </div>
                        <div className="col-md-9">
                            <input type="text" maxLength={20} className="form-control" id="admin-company-website-version" value={companyData.website_version} onChange={handleChange("website_version")} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-company-status">{t('PageAdmin.CompanyTable.Status')}</label>
                        </div>
                        <div className="col-md-9">
                            <select
                                className="form-control"
                                id="admin-company-status"
                                value={companyData.is_enabled}
                                onChange={handleChange("is_enabled")}
                            >
                                <option value={true}>{t('PageAdmin.CompanyStatus.Normal')}</option>
                                <option value={false}>{t('PageAdmin.CompanyStatus.Stopped')}</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-company-user-manual">{t('PageAdmin.CompanyTable.UserManual')}</label>
                        </div>
                        <div className="col-md-9">
                            <input type="text" maxLength={100} className="form-control" id="admin-company-user-manual" value={companyData.user_manual} onChange={handleChange("user_manual")} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-company-remark">{t('PageAdmin.CompanyTable.Remark')}</label>
                        </div>
                        <div className="col-md-9">
                            <textarea
                                rows={3}
                                maxLength={500}
                                className="form-control"
                                id="admin-company-remark"
                                value={companyData.remark || ''}
                                onChange={handleChange("remark")}
                                style={{ resize: 'vertical', overflowY: 'auto' }}
                            />
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-column align-items-center company-save-modal-btn-container">
                    {isShowError ? <div className="company-save-modal-error">{t('PageAdmin.SaveCompanyModal.SaveError')}</div> : null}
                    <div className="d-flex flex-row justify-content-center ">
                        <Button className="btn-sm report-save-modal-btn" color="primary" onClick={() => {
                            closeModal(false)
                        }}> {t('PageReport.SaveReportModal.BtnCancel')} </Button>
                        <Button className="btn-sm report-save-modal-btn" color="primary" onClick={async () => {
                            let result = false;
                            if (isNewCompany) {
                                console.log(companyData);
                                result = await dispatch(createAdminCompany(companyData));
                            }
                            else {
                                result = await dispatch(updateAdminCompany(companyData));
                            }
                            if (result === true) {
                                setShowError(false);
                                closeModal(true);
                            } else {
                                setShowError(true);
                            }
                        }}> {t('PageReport.SaveReportModal.BtnSave')} </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
}

export default AdminCompanyModal;